// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQSettingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { PureComponent } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Button from 'share/components/controls/Izenda.Button';
import connect from 'share/enhancers/Izenda.Connect';
import {
  CLAZZNAME,
  RESET_CONFIG_MESSAGE,
  REQUEST_MODE
} from 'logic/data/Izenda.NLQConfigurationConstants';
import ProgressBar from 'share/components/controls/ProgressBar/Izenda.ProgressBar';


@connect({ toClass: true })
class NLQSettingConfiguration extends PureComponent {
  constructor(props) {
    super(props);
  }

  onClickConfigureNLQ = () => {
    const { store: { nlqConfigurationModel } } = this.props;
    nlqConfigurationModel.updateRequestMode(REQUEST_MODE.CONFIG);
    nlqConfigurationModel.updateIsSwitchDisable(true);
    nlqConfigurationModel.updateIsProressBar(true);
    this.props.store
      .saveConfigureforNLQ(nlqConfigurationModel.selectedConnection.connectionId, nlqConfigurationModel.searchMode)
      .then(data => {
        nlqConfigurationModel.saveNLQConfiguration(data);
      })
      .catch(function (error) {
        nlqConfigurationModel.errorNLQConfiguration(error);
      });
  };


  onClickResetNLQ = () => {
    var props = this.props;
    var loader = props.loader;
    const { store: { nlqConfigurationModel } } = this.props;
    props
      .confirmFn('Confirmation', {
        description: RESET_CONFIG_MESSAGE
      })
      .then(loader.startLoading.bind(loader))
      .then(() => {
        return props.store
          .ResetNLQ(nlqConfigurationModel.searchMode)
          .then(data => {
            nlqConfigurationModel.resetNLQConfiguration(data);
          })
          .catch(function (error) {
            nlqConfigurationModel.errorNLQConfiguration(error);
          });
      })
      .finally(loader.endLoading.bind(loader));
  };

  onConnectorTypeChange = selectedConnector => {
    const { store: { nlqConfigurationModel } } = this.props;
    const selectedValue = {
      dbName: selectedConnector.label,
      connectionId: selectedConnector.value
    };
    nlqConfigurationModel.updateonConnectorTypeChange(selectedValue);
  };

  render() {
    let localization = this.props.localization;
    const { store: { nlqConfigurationModel } } = this.props;

    return (
      <div>
        <GridLayout.Row>
          <GridLayout.Col cols={3}>
            <label className={CLAZZNAME}>{localization.getText('NLQ_CONFIGURATION_SETTINGS_DATACONNECTORS')}</label>
          </GridLayout.Col>
          <GridLayout.Col cols={9}>
            <DropDown
              disabled={nlqConfigurationModel.isProressBar}
              labelField='name'
              valueField='id'
              blankOption
              blankOptionText={'Select Active NLQ'}
              options={nlqConfigurationModel.connectionList}
              value={nlqConfigurationModel.selectedConnection.connectionId}
              onChange={this.onConnectorTypeChange}
              ref={`dbConnectionType`}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols={2}>
            <Button
              onClick={this.onClickConfigureNLQ}
              disabled={nlqConfigurationModel.isConfigureDisable}
              className='btn btn-default confi_cusBtn'
              defaultClasses={true}
              label={localization.getText('NLQ_CONFIGURATION_CONFIG_BUTTON')}
            />
            &nbsp;
          </GridLayout.Col>
          <GridLayout.Col cols={2}>
            <Button
              onClick={this.onClickResetNLQ}
              disabled={nlqConfigurationModel.isProressBar || nlqConfigurationModel.schemaKey == null}
              className='btn btn-default confi_cusBtn'
              defaultClasses={true}
              label={localization.getText('NLQ_CONFIGURATION_RESET_BUTTON')}
            />
          </GridLayout.Col>
          <GridLayout.Col cols={7}>
            {
              <ProgressBar
                isProressBar={nlqConfigurationModel.requestMode != REQUEST_MODE.SWITCH ? nlqConfigurationModel.isProressBar : false}
                message={nlqConfigurationModel.message}
                schemaStatus={nlqConfigurationModel.schemaStatus}
              />}
          </GridLayout.Col>
        </GridLayout.Row>
      </div>
    );
  }
}
export default NLQSettingConfiguration;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/NlqConfiguration/Izenda.NLQSettingConfiguration.js